<template>
  <base-container>
    <el-form
      ref="elForm"
      :model="form"
      :rules="rules"
      size="medium"
      disabled
      label-width="100px"
    >
      <el-form-item label="主标题" prop="title">
        <el-input
          v-model="form.title"
          placeholder="请输入主标题"
          :maxlength="20"
          show-word-limit
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <div v-html="form.content" />
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input
          v-model="form.comment"
          placeholder="请输入单行文本"
          clearable
          :maxlength="30"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item size="small">
        <el-button class="mr8" type="primary">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </base-container>
</template>
<script>
/**
 * 内容管理-协议管理-详情
 */
import { getFaqInfo } from '@/api/content'
export default {
  name: 'HelpCenterDetail',
  components: {
  },
  props: [],
  data() {
    return {
      form: {
        title: '',
        content: null,
        comment: ''
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入主标题',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择协议类型',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入协议内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    resetForm() {
      this.$refs['elForm'].resetFields()
    },
    initData() {
      const { id } = this.$route.query
      getFaqInfo({ id }).then((res) => {
        this.form = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement-container {
  margin: 10px;
  background: #fff;
  min-height: 768px;
  .add-agreement-container {
    padding-top: 50px;
    display: flex;
    justify-content: center;
  }
}
</style>

